var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blackMaterial"},[(_vm.internalUrl)?_c('iframe',{staticClass:"iframe",style:({ height: _vm.downBanner.length > 0 ? '60%' : '90%' }),attrs:{"src":_vm.internalUrl,"frameborder":"0"}}):_vm._e(),_c('div',{staticClass:"sizeBox"})])
}
var staticRenderFns = []

export { render, staticRenderFns }